'use client';

import { useGoogleAnalytics, useScrollDepthTracking, useEngagementTracking } from '@/lib/analytics';

export default function GoogleAnalytics() {
  useGoogleAnalytics();
  useScrollDepthTracking();
  useEngagementTracking();
  
  return null;
}
